// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2BNF_","label":"LabeledBox_label__3k0RR"};